/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function Button(props) {
  const {
    onClick,
    type,
    isExternal,
    href,
    className,
    style,
    target,
    children,
    location: locationProp, // eslint-disable-line react/prop-types
  } = props;

  // Always call useLocation hook (required by React hooks rules)
  // But use locationProp if provided (from class components)
  const hookLocation = useLocation();
  const location = locationProp || hookLocation;
  let isActive = false;

  if (location) {
    if (href === '/') {
      isActive = location.pathname === '/';
    } else {
      isActive = location.pathname === href || location.pathname.startsWith(`${href}/`);
    }
  }

  const onClickHandler = (e) => {
    if (onClick) {
      onClick(e);
    }
    // Let Link handle navigation naturally - don't prevent default
  };

  if (type === 'link') {
    if (isExternal) {
      return (
        <a
          href={href}
          className={className}
          style={style}
          target={target === '_blank' ? '_blank' : undefined}
          rel="noreferrer"
        >
          {children}
        </a>
      );
    }

    if (!href || href === '') {
      return <span className={className} style={style}>{children}</span>;
    }

    let linkClassName = '';
    if (className) {
      linkClassName = `${className} ${isActive ? 'active-link' : ''}`;
    } else if (isActive) {
      linkClassName = 'active-link';
    }
    const linkStyle = {
      ...style,
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block',
      position: 'relative',
      zIndex: 1,
    };

    return (
      <Link
        to={href || '/'}
        className={linkClassName}
        style={linkStyle}
        onClick={onClickHandler}
        replace={false}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={className}
      type={type}
      style={style}
      onClick={onClickHandler}
    >
      {children}
    </button>
  );
}

Button.defaultProps = {
  className: '',
  type: 'button',
  href: '',
  onClick: () => {},
  target: '',
  style: {},
  children: '',
  isExternal: '',
  location: undefined,
};

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'link', 'submit', 'reset']),
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isExternal: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object,
};
